import api from '@sparemin/api-sdk';
import { useCallback, useMemo } from 'react';
import {
  EventTrackingContextType,
  SendSponsoredEpisodeEventConfig,
} from '../types';

export default function useSponsoredEpisodeEventTracking(): Pick<
  EventTrackingContextType,
  'trackSponsoredEpisodeClickThrough' | 'trackSponsoredEpisodePlayed'
> {
  const trackSponsoredEpisodePlayed = useCallback(
    (props: SendSponsoredEpisodeEventConfig) => {
      const { resultProp, ...eventProps } = props;
      api.sendBeaconEvent({
        event: 'playSpResultPlayed',
        ...eventProps,
        properties: {
          playedResult: resultProp,
        },
      });
    },
    [],
  );

  const trackSponsoredEpisodeClickThrough = useCallback(
    (props: SendSponsoredEpisodeEventConfig) => {
      const { resultProp, ...eventProps } = props;

      api.sendBeaconEvent({
        event: 'playSpClickThrough',
        ...eventProps,
        properties: {
          ctResult: resultProp,
        },
      });
    },
    [],
  );

  return useMemo(
    () => ({
      trackSponsoredEpisodeClickThrough,
      trackSponsoredEpisodePlayed,
    }),
    [trackSponsoredEpisodeClickThrough, trackSponsoredEpisodePlayed],
  );
}
